import React, { useContext } from "react";
import { Grid, Box, Typography } from "@mui/material";

import styles from "./HospAdminUserListTable.module.css";
import AppContext from "../../context/AppContext";
import thm from "../theme";

const createStyles = () => ({
  purpleShade: {
    backgroundColor: thm.palette.primary.light,
    paddingTop: "10px",
    paddingBottom: "10px",
  },
});

export const UserListHeader: React.FC = () => {
  const isDesktop = useContext(AppContext).isDesktop;
  const classes = createStyles();

  return (
    <Box mx={isDesktop ? 1 : 0} my={0.2} px={isDesktop ? 2 : 0} py={1}>
      <Grid container sx={classes.purpleShade}>
        <Grid
          container
          size={{
            xs: "grow",
            sm: "grow",
            md: "grow",
          }}
        >
          <Grid
            size={{
              xs: 4,
              sm: 4,
              md: 4,
              lg: 2,
            }}
          >
            <Typography className={isDesktop ? styles.headerText : styles.headerTextMob}>Username</Typography>
          </Grid>
          <Grid
            sx={{ display: { xs: "none", lg: "block" } }}
            size={{
              xs: "grow",
              sm: 2,
              md: 2,
              lg: 2,
            }}
          >
            <Typography className={styles.headerText}>Name</Typography>
          </Grid>
          <Grid sx={{ display: { xs: "none", lg: "block" } }} size="auto"></Grid>
          <Grid
            sx={{ display: { xs: "none", lg: "block" } }}
            size={{
              xs: "grow",
              sm: "grow",
              md: "grow",
              lg: 2,
            }}
          >
            <Typography className={styles.headerText}>Email</Typography>
          </Grid>
          <Grid
            size={{
              xs: 4,
              sm: 4,
              md: 4,
              lg: 1,
            }}
          >
            <Typography className={isDesktop ? styles.headerTextNpPad : styles.headerTextMob}>
              Group Administrator
            </Typography>
          </Grid>
          <Grid
            sx={{ display: { xs: "none", lg: "block" } }}
            size={{
              xs: 1,
              sm: 2,
              md: 1,
              lg: 1,
            }}
          >
            <Typography className={styles.headerTextNpPad}>Shared Account</Typography>
          </Grid>
          <Grid
            sx={{ display: { xs: "none", lg: "block" } }}
            size={{
              xs: 1,
              sm: 2,
              md: 1,
              lg: 1,
            }}
          >
            <Typography className={styles.headerTextNp}>Last Login</Typography>
          </Grid>
          <Grid
            sx={{ display: { xs: "none", lg: "block" } }}
            size={{
              xs: 1,
              sm: 2,
              md: 1,
              lg: 1,
            }}
          >
            <Typography className={styles.headerTextNp}>Last IP</Typography>
          </Grid>
          <Grid
            size={{
              xs: 2,
              sm: 2,
              md: 2,
              lg: 1,
            }}
          >
            <Typography className={styles.headerTextNpPad}>Action</Typography>
          </Grid>
          <Grid
            size={{
              xs: 2,
              sm: 1,
              md: 1,
              lg: 1,
            }}
          >
            <Typography className={isDesktop ? styles.headerText : styles.headerTextMpMob}>Enable</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
